import React, { Component, useState, useEffect } from 'react';
import { graphConfig } from "./authConfig";
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { browserName, browserVersion } from 'react-device-detect';
import { Layout } from './components/Layout';
import { Footer } from './components/footer';
import { Home } from './components/Home';
import { UnderConstruction } from './components/UnderConstruction';
import UserContext from './tools/contextLib';
import { NavMenu } from './components/NavMenu';
import { DormTrans } from './components/DormTrans';
import { AccessForbidden } from './components/AccessForbidden';
import { HonorsKeycardAccess } from './components/HonorsKeycardAccess';
import { RegistrarDashboard } from './components/RegistrarDashboard';
import { GenDormAccess } from './components/GenDormAccess';
import { Acadeum } from './components/Acadeum';
import { HeadCoaches } from './components/HeadCoaches';
import { Beacon } from './components/Beacon';
import { EmployeeDirectory } from './components/EmployeeDirectory';
import { Accounting } from './components/Accounting';
import { Admin } from './components/Admin';
import { SectionScheduling } from './components/SectionScheduling';
import { DepartmentHeads } from './components/DepartmentHeads';
import { CipCode } from './components/CipCode';
import { BeaconConn } from './components/BeaconConn';
import { Praxis } from './components/Praxis';
import { MergeDepartment } from './components/MergeDepartment';
import { FormsDashboard } from './components/FormsDashboard';
import { TermsControlBB } from './components/TermsControlBB';
import { CounselorControl } from './components/CounselorControl';
import { ExamScheduling } from './components/ExamScheduling';
import { ContractDates } from './components/ContractDates';
import { VaxxRecord } from './components/VaxxRecord';
import { NoReplyEmail } from './components/NoReplyEmail';
import { AthleteKeycard } from './components/AthleteKeycardManagement';
import { VendorDB } from './components/VendorDB';
import { StuCheckCart } from './components/StuCheckCart';
import { DistroLists } from './components/DistroLists';
import { DormAssign } from './components/DormAssign';
import './custom.css'
import LoadingSpin from "react-loading-spin";

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, MsalAuthenticationTemplate, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType, InteractionStatus } from "@azure/msal-browser";
import  moment  from 'moment';

export default function App() {
    //const { instance, accounts, inProgress } = useMsal();
    //useMsalAuthentication(InteractionType.Redirect);
    useEffect(() => {
        localStorage.setItem("lastFetch", moment());
    }, [])
    return (
        <div>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <UnauthenticatedTemplate>
                    <div>
                        <LoadingSpin size="30px" primaryColor="#86d3ff" />
                    </div>
                </UnauthenticatedTemplate>
                <AuthenticatedTemplate>
                    <PageAuth  />
                    </AuthenticatedTemplate>
            </MsalAuthenticationTemplate>
        </div>)

}

const PageAuth = (props) => {
    const { instance, accounts, inProgress } = useMsal();
    const [currToken, setCurrToken] = useState();
    const [staleCheckTime, setStaleCheckTime] = useState(moment());
    const [refreshTicker, setRefreshTicker] = useState(1);
    let uthAcct = accounts.filter(acct => { if (window.location.host == "underthehood.hood.edu") { return acct.idTokenClaims.aud === "bcc2bb9d-a743-40ce-9d19-f617c997fe4b" } else { return acct.idTokenClaims.aud === "579a5cf4-f372-4d2b-9b4a-43700b470b88" } })
    instance.setActiveAccount(uthAcct);
    const accessTokenRequest = {
        scopes: ["user.read"],
        account: instance.getActiveAccount(),
        //account: accounts[0]
    };

    useEffect(() => {
        //console.log("recycle check: compare " + Date.parse(localStorage.getItem("lastFetch")) + " to " + Date.parse(moment().subtract(45, 'm')));
        //console.log("time calculation: now " + moment() + ", hour ago: " + moment().minute(-45));
        if (Date.parse(localStorage.getItem("lastFetch")) <= Date.parse(moment().subtract(45, 'm'))) {
            //console.log("found stale. accounts: " + JSON.stringify(accounts));
            localStorage.removeItem("webApiAccessToken");
            localStorage.removeItem("lastFetch");

            //instance.logoutRedirect({
            //    account: instance.getActiveAccount(),
            //    postLogoutRedirectUri: "https://www.hood.edu"
            //});
            window.location.replace("https://www.hood.edu");

            //instance.acquireTokenRedirect({
            //    scopes: ["user.read"],
            //    account: accounts[0],
            //})
        }
        if (Date.parse(localStorage.getItem("lastFetch")) > staleCheckTime) {
            //console.log("need update");
            
            instance.acquireTokenSilent(accessTokenRequest)
                .then(function (accessToken) {
                    //console.log("access token found: " + JSON.stringify(accessToken.accessToken));
                    setCurrToken(accessToken.accessToken);
                    localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                }, function (error) {
                    instance.acquireTokenRedirect(accessTokenRequest).then(function (accessToken) {
                        //console.log("access token from redirect found: " + accessToken);
                        setCurrToken(accessToken);
                        localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                    }, function (error) {
                        //console.log("total failure: " + error);
                    })
                })
        }
        setStaleCheckTime(moment());
        setTimeout(() => { setRefreshTicker(refreshTicker + 1) }, 120000) //120000
    }, [refreshTicker])
    
    useEffect(() => {
        //console.log("initial useEffect in PageAuth. checking: accounts.length = " + accounts.length + " and inProgress = " + inProgress)
        //console.log("active account: " + JSON.stringify(instance.getActiveAccount()))
        //const thisInstance = new PublicClientApplication({ auth: { clientId: "579a5cf4-f372-4d2b-9b4a-43700b470b88" } })
        //await thisInstance.initialize();
        //console.log("in initMSAL authResponse: " + authResponse.accessToken);
        //var result = instance.acquireTokenRedirect({scopes: ["user.read"],account: accounts[0]})
        if (accounts.length > 0 && (inProgress === InteractionStatus.None || instance.getActiveAccount() != null)) {
            ///console.log("acquiring token")
            instance.acquireTokenSilent(accessTokenRequest)
                .then(function (accessToken) {
                   // console.log("access token found: " + JSON.stringify(accessToken.accessToken));
                    
                    //getPages(accessToken.accessToken);
                    localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                    setCurrToken(accessToken.accessToken);
                    //var dateNow = new Date().toLocaleTimeString();
                    //console.log("datenow: " + new Date().toLocaleTimeString())
                    localStorage.setItem("lastFetch", moment());
                }, function (error) {
                    instance.acquireTokenRedirect(accessTokenRequest).then(function (accessToken) {
                        //console.log("access token from redirect found: " + accessToken);
                        
                        //getPages(accessToken);
                        localStorage.setItem("webApiAccessToken", accessToken.accessToken);
                        setCurrToken(accessToken.accessToken);
                        //var dateNow = new Date().toLocaleTimeString();
                        //console.log("datenow: " + new Date().toLocaleTimeString())
                        localStorage.setItem("lastFetch", moment());
                    }, function (error) {
                        //console.log("total failure: " + error);
                    })
                })
            //.then(response => {
            //    console.log("response: " + JSON.stringify(response))
            //    if (response.accessToken) {
            //        console.log("access token: " + response.accessToken)
            //        setToken(response.accessToken);
            //        if (response.idToken) {
            //            console.log("id token: " + response.idToken)
            //            setIdToken(response.idToken)
            //        }
            //        else {console.log("no id token") }
            //        getPages(response.accessToken);
            //        //getAuthReq(response.accessToken);
            //    }
            //    else {
            //        console.log("no token");
            //    }
            //})
            ////.then(responseToken => { getPages() })
            //.catch(error => {
            //    console.log("error: " + error)
            //    if (error instanceof InteractionRequiredAuthError) {
            //        thisInstance.acquireTokenRedirect(accessTokenRequest)
            //    }
            //}
            //)
        }

        
        
        //fetch('user')
        //    .then((response) => response.json())
        //    .then((responseJSON) => {

        //        if (responseJSON.email != accounts[0].username) {
        //            let toSend = {
        //                serverUser: responseJSON.username,
        //                azureUser: accounts[0].username
        //            }
        //            fetch('RecordMismatch', {
        //                method: 'POST',
        //                headers: { 'Content-Type': 'application/json' },
        //                body: JSON.stringify(toSend)
        //            })
        //            setUserInfo(responseJSON);
        //            console.log("check failed");
        //            console.log("server data: " + JSON.stringify(responseJSON));
        //            console.log("azure data: " + JSON.stringify(accounts[0]));
        //        }
        //        //else { setUserInfo(responseJSON); }
        //    })
    }, [])

    //useEffect(() => {
    //    console.log("currToken update: " + currToken)
    //}, [currToken])

    let displaySite = <div></div>
    if (currToken != null && currToken != "undefined") {
        displaySite = < SiteView currToken={currToken} />
        //console.log("redering SiteView with currToken: " + currToken)
        //displaySite = <SiteView />
    }
    return (
        <div>
            <UnauthenticatedTemplate>
                <div></div>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                {displaySite}
            </AuthenticatedTemplate>
        </div>
     )
}

const SiteView = (props) => {
    const { instance, accounts, inProgress } = useMsal();
    let uthAcct = accounts.filter(acct => { if (window.location.host == "underthehood.hood.edu") { return acct.idTokenClaims.aud === "bcc2bb9d-a743-40ce-9d19-f617c997fe4b" } else { return acct.idTokenClaims.aud === "579a5cf4-f372-4d2b-9b4a-43700b470b88" } })
    instance.setActiveAccount(uthAcct);
    //console.log("SiteView");
    //static displayName = App.name;
    const [profile, setProfile] = useState(null);
    const [token, setToken] = useState(props.currToken);
    //const [profileSetter, setProfileSetter] = useState();//needed?
    const [returnable, setReturnable] = useState([]);
    const [selectables, setSelectables] = useState([]);
    const [globalLevel, setGlobalLevel] = useState("");
    const [browser, setBrowser] = useState(`${browserName}${browserVersion}`);
    const [pageName, setPageName] = useState("");
    const [levelSwitchFlag, setLevelSwitchFlag] = useState(false);
    const [pages, setPages] = useState([]);
    const [thisPage, setThisPage] = useState(1);
    const [userInfo, setUserInfo] = useState([]);
    const [graph, setGRAPH] = useState([]);
        //this.state = {
        //    profile: null,
        //    setProfile: this.setProfile,
        //    returnable: [],
        //    selectables: ["3", "4"], //I like the pizza kind
        //    globalLevel: "Please select a browsing level",
        //    department: "",
        //    browser: `${browserName}${browserVersion}`,
        //    pageName: "",
        //    levelSwitchFlag: false,
        //    pages: [".", ","],
        //    thisPage: 1
        
        //populateDropdown(); //This is only called populateDropdown() because the function was copy/pasted from where the UserController fetch was first written in NavMenu.js
                                 //Regardless, it does the same thing of fetching user information
    
    //half of the functions here are probably outdated and can be pruned out
    const setGlobalStateCallback = (dataFromChild) => {
        //console.log("setGlobalStateCallback: " + dataFromChild);
        setLevelSwitchFlag(true);
        //this.setState({
        //    levelSwitchFlag: true //Yes, I'm doing two different setState functions, but I want to make sure this one is set before the next one
        //}) //This flag will be passed as a prop to all of the components, and when those components render they'll read this prop and redirect the user to Home.js if it's true. This way,
        //whenever a user changes their level, they'll immediately be sent home to avoid accidentally landing in AccessForbidden.js when all they did is change their level to a level
        //that doesn't have permission to see a page their previous level did
        setGlobalLevel(dataFromChild);
        //this.setState({
        //    globalLevel: dataFromChild
        //});
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSendVAR = {
            level: globalLevel
        }
        //console.log("callback PageFind")
        fetch('PageFind', {
            method: 'POST',
            headers:
            {
                'Content-Type': 'application/json',
                'Authorization': bearerVAR
            },
            body: JSON.stringify(toSendVAR)
        })
            .then((response2) => response2.json())
            .then((responseJSON2) => {
                setPages(responseJSON2);
            })
        localStorage.setItem("lastFetch", moment());
    
        //getPages();
        setTimeout(() => { //This whole level switching state value to indicate when to redirect to home is a dumb stupid hack that wound up blocking access to any page but home when you change level
            setLevelSwitchFlag(false);
            //this.setState({ //and the fact that the fix for that was an even dumber stupider hack fills me with pride
            //    levelSwitchFlag: false
            //})
        }, 1200) //It's important to note in here that this timeout before this.state.levelSwitchFlag means that there's a second and a half long lockout where a user selecting a 
        //new page will not actually go to said page. This is fine, since the user will just assume they misclicked or something, it's only a second and a half
    }

    const setPageTitle = (dataFromChild) => {
        //this.setState({
        //    pageName: dataFromChild
        //})
        setPageName(dataFromChild);
    }

 

    //function findBrowserInfo(dataFromChild) { //This is from an old attempt at logging where I'd pass the page number to this function via props and it would do the logging.
    //    let toSend = { //Even though it didn't really work out, it's something I still want to investigate in the future
    //        pagePK: dataFromChild,
    //        department: this.state.returnable.level,
    //        userPCID: this.state.returnable.pcid,
    //        ip: this.state.returnable.ip,
    //        browser: this.state.browser,
    //        userID: this.state.returnable.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json' },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //}

    //function populateDropdown() {
    //    const response = await fetch('user');
    //    const data = await response.json();
    //    this.setState({
    //        returnable: data,
    //        loading: false,
    //        selectables: data.values,
    //        browser: `${browserName}${browserVersion}`
    //    });
    //    this.setState({
    //        globalLevel: this.state.returnable.level
    //    });
    //    this.getPages();
    //}

    useEffect(() => {
        
        let bearerVAR = "Bearer " + token;
        //console.log("in main useEffect. bearerVAR: " + bearerVAR)
        //console.log("alternate token: " + props.currToken)
        fetch('User', {
            method: 'GET',
            headers: {
                'Authorization': bearerVAR
            }
        })
            .then((response) => response.json())
            .then((responseJSON) => { setUserInfo(responseJSON) 
            
                //console.log("setting state : " + responseJSON.level + " and " + JSON.stringify(responseJSON.values))
                setSelectables(responseJSON.values);
                setGlobalLevel(responseJSON.level);
                setReturnable(responseJSON);
                let toSend = {
                    level: responseJSON.level
                }
            fetch('PageFind', {
                method: 'POST',
                headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': bearerVAR
                },
                body: JSON.stringify(toSend)
                })
                .then((response2) => response2.json())
                .then((responseJSON2) => {
                    setPages(responseJSON2);
                })
            })
        
    }, [])

    //async getPages() {

    //    let toSend = {
    //        level: this.state.globalLevel
    //    }
    //    const response = await fetch('PageFind', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json' },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();

    //    this.setState({
    //        pages: data
    //    })
    //}

    const receiveNewPage = (pk) => {
        setThisPage(pk);
        //this.setState({
        //    thisPage: pk
        //})
    }

    const logoutCallback = () => {
        //let redirect;
        //if (window.location.host == "underthehood.hood.edu") {
        //    redirect = "undertheh";
        //}
        //else { msalInstance = new PublicClientApplication(msalConfigTEST) }
        instance.logoutRedirect({
            account: instance.getActiveAccount(),
            postLogoutRedirectUri: "https://www.hood.edu"
        });
    }

    //render() {
        //const globalLevel = globalLevel; //This is a way of pre-processing the information we're putting into context, to make sure it's being provided properly
        const nameOfUser = userInfo.tester;
        //const selectables = selectables;
        const PCID = userInfo.pcid;
        //const pageName = pageName;
        //const pages = pages;//If you add to the list of items being used in context, please add to the Teams documentation on upload
        //The only prop here that's necessary in the majority of the components is justSwitch since it's what lets the components know they need to redirect to Home due to a recent
        //level switch. However, in the future I plan on using setPageTitle to govern the page title content in NavMenu.js instead of simply using state changes inside the component
        //to get around the refresh issue. This is one of those things that is in the category "Important Things To Do right after this time-sensitive component that you just got now"
        if (window.location.pathname != '/') {
            return <Redirect to='/' />
    }
        //console.log("selectables: " + JSON.stringify(selectables))
        return (

            //passNewPage={this.receiveNewPage}
            //this.props.passNewPage(-1);

        <Layout>
                <UserContext.Provider value={[globalLevel, nameOfUser, selectables, PCID, pageName, pages]}>
                    <NavMenu setGlobalStateCallback={setGlobalStateCallback} pageNameCheck={pageName} passNewPage={receiveNewPage} initPages={pages} logoutPROP={logoutCallback} />
                    {thisPage == 1 && <Home setPageTitle={setPageTitle} />}
                    {thisPage == 0 && <Beacon justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} setPageTitle={setPageTitle} />}
                    {thisPage == 8 && <DormTrans setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} /> }
                {/*<Route path='/dormSpecialAccess' component={() => <DormTrans setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} resetSwitch={this.resetLevelSwitchFlag} />} />*/}
                    {thisPage == 1023 && <Acadeum justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} /> }
                    {thisPage == 1022 && <HonorsKeycardAccess setPageTitle={setPageTitle} justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1024 && <RegistrarDashboard setPageTitle={setPageTitle} justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} />}
                    {thisPage == 0 && <GenDormAccess setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} /> }
                    {thisPage == 1021 && <HeadCoaches justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} setPageTitle={setPageTitle} /> }
                    {thisPage == 6 && <EmployeeDirectory justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1025 && <Accounting justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == 3 && <Admin justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == 18 && <SectionScheduling justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage}  /> }
                    {thisPage == 1026 && <DepartmentHeads justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1027 && <CipCode justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} />}
                    {thisPage == 1028 && <BeaconConn justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1029 && <Praxis justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1031 && <FormsDashboard justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1030 && <MergeDepartment justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1032 && <TermsControlBB justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1033 && <CounselorControl justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} /> }
                    {thisPage == 1034 && <ExamScheduling justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1035 && <ContractDates justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1036 && <VaxxRecord justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1037 && <NoReplyEmail justSwitch={levelSwitchFlag} setPageTitle={setPageTitle}  passNewPage={receiveNewPage} /> }
                    {thisPage == 1038 && <AthleteKeycard justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == 1039 && <VendorDB justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} userData={returnable} /> }
                    {thisPage == 1040 && <StuCheckCart justSwitch={levelSwitchFlag}  passNewPage={receiveNewPage} />}
                    {thisPage == 1041 && <DistroLists justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
                    {thisPage == 1042 && <DormAssign justSwitch={levelSwitchFlag} setPageTitle={setPageTitle} passNewPage={receiveNewPage} />}
               {/* <Route path='/not-done-yet' component={UnderConstruction} />*/}
                    {thisPage == -1 && <AccessForbidden setPageTitle={setPageTitle} justSwitch={levelSwitchFlag} passNewPage={receiveNewPage} />}
                <Footer />
            </UserContext.Provider>
        </Layout>
        ); //We use the arrow function syntax for components to route to in order to make sure we can pass props to it. NavMenu is not routed to because it should always be there
           //I know there are better ways to do that, but there are more important concerns with this site

           
   // }
}
